import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  static targets = ['hours', 'minutes', 'seconds']
  static values = {
    duration: Number,
    redirectUrl: String // optional
  }

  connect() {
    this.remaining = this.durationValue
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    this.updateDisplay()
    this.timer = setInterval(() => {
      if (this.remaining > 0) {
        this.remaining--
        this.updateDisplay()
      } else {
        this.stop()
        this.finish()
      }
    }, 1000)
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  updateDisplay() {
    const hours = Math.floor(this.remaining / 3600)
    const minutes = Math.floor((this.remaining % 3600) / 60)
    const seconds = this.remaining % 60

    this.hoursTarget.textContent = String(hours).padStart(2, '0')
    this.minutesTarget.textContent = String(minutes).padStart(2, '0')
    this.secondsTarget.textContent = String(seconds).padStart(2, '0')
  }

  finish() {
    this.dispatch('coundown:finished')

    if (this.hasRedirectUrlValue) {
      Turbo.visit(this.redirectUrlValue)
    }
  }
}